export const Spinner = {
  baseStyle: {
    color: 'blue.500',
  },
};
